import { useEffect } from 'react';

import { getCurrentLanguage } from '@/locales/language';

import { getProfileAsset } from './profile';
import type { IRealmProfileSnapshot } from './types';

/** useRealmDocumentMetadata 将渠道 description 与 favicon 应用于整个 tenant-web 文档。 */
export function useRealmDocumentMetadata(profile?: IRealmProfileSnapshot): void {
  useEffect(() => {
    if (!profile) return undefined;
    const locale = getCurrentLanguage();
    const description = profile.webProfile.documentMeta.descriptionI18n?.[locale]
      || profile.webProfile.documentMeta.description;
    const favicon = getProfileAsset(profile, profile.webProfile.brand.faviconAssetKey)?.src;
    const descriptionElement = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    const faviconElement = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    const previousDescription = descriptionElement?.content;
    const previousFavicon = faviconElement?.href;

    if (description && descriptionElement) descriptionElement.content = description;
    if (favicon && faviconElement) faviconElement.href = favicon;

    return () => {
      if (descriptionElement && previousDescription !== undefined) descriptionElement.content = previousDescription;
      if (faviconElement && previousFavicon !== undefined) faviconElement.href = previousFavicon;
    };
  }, [profile]);
}
